import { defineComponent, computed, createBlock, unref, openBlock, resolveDynamicComponent, mergeProps, withCtx, createCommentVNode, createElementBlock, Fragment, renderList } from "vue";
import { isFilled } from "@prismicio/client";
import { defaultTableComponents } from "./PrismicTableDefaultComponents.js";
import _sfc_main$1 from "./PrismicTableRow.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicTable" },
  __name: "PrismicTable",
  props: {
    field: {},
    fallback: {},
    components: {}
  },
  setup(__props) {
    const props = __props;
    const mergedComponents = computed(() => ({
      ...defaultTableComponents,
      ...props.components
    }));
    return (_ctx, _cache) => {
      return unref(isFilled).table(_ctx.field) ? (openBlock(), createBlock(resolveDynamicComponent(mergedComponents.value.table), mergeProps({
        key: 0,
        table: _ctx.field
      }, _ctx.$attrs), {
        default: withCtx(() => [
          _ctx.field.head ? (openBlock(), createBlock(resolveDynamicComponent(mergedComponents.value.thead), {
            key: 0,
            head: _ctx.field.head
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.field.head.rows, (row) => {
                return openBlock(), createBlock(_sfc_main$1, {
                  key: row.key,
                  row,
                  components: mergedComponents.value
                }, null, 8, ["row", "components"]);
              }), 128))
            ]),
            _: 1
          }, 8, ["head"])) : createCommentVNode("", true),
          (openBlock(), createBlock(resolveDynamicComponent(mergedComponents.value.tbody), {
            body: _ctx.field.body
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.field.body.rows, (row) => {
                return openBlock(), createBlock(_sfc_main$1, {
                  key: row.key,
                  row,
                  components: mergedComponents.value
                }, null, 8, ["row", "components"]);
              }), 128))
            ]),
            _: 1
          }, 8, ["body"]))
        ]),
        _: 1
      }, 16, ["table"])) : (openBlock(), createBlock(resolveDynamicComponent(_ctx.fallback), { key: 1 }));
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicTable.vue.js.map
